import { FaBalanceScale, FaRegLightbulb, FaUsers } from "react-icons/fa";

import Card from "../Card/index.jsx";

const pillars = [
  {
    icon: FaBalanceScale,
    title: "Postura técnica",
    text: "A análise jurídica é feita com critério, clareza e foco no que realmente importa.",
  },
  {
    icon: FaRegLightbulb,
    title: "Estratégia prática",
    text: "O objetivo é orientar com segurança e transformar complexidade em decisão objetiva.",
  },
  {
    icon: FaUsers,
    title: "Atendimento próximo",
    text: "O cliente acompanha o andamento com comunicação direta e sem excesso de formalidade.",
  },
];

export default function About() {
  return (
    <section
      id="areas"
      className="border-y border-amber-950/10 bg-[#f4ede1] py-24 text-slate-900"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-amber-700">
            Escritório
          </p>
          <h2 className="mt-4 text-4xl font-semibold tracking-tight text-slate-950 sm:text-5xl">
            Áreas de atuação e método de trabalho
          </h2>
          <p className="mt-5 text-lg leading-8 text-slate-600">
            O escritório atua de forma personalizada, com análise individual de
            cada caso, comunicação objetiva e foco em soluções seguras para
            pessoas físicas e jurídicas.
          </p>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-3">
          {pillars.map((pillar) => {
            const Icon = pillar.icon;

            return (
              <article
                key={pillar.title}
                className="rounded-[1.5rem] border border-amber-950/10 bg-white p-6 shadow-[0_16px_40px_rgba(15,23,42,0.05)]"
              >
                <Icon className="text-xl text-amber-700" />
                <h3 className="mt-4 text-2xl font-semibold text-slate-950">
                  {pillar.title}
                </h3>
                <p className="mt-3 text-sm leading-7 text-slate-600">
                  {pillar.text}
                </p>
              </article>
            );
          })}
        </div>

        <div className="mt-16">
          <Card />
        </div>
      </div>
    </section>
  );
}
